import Vue from 'vue'
import Router from 'vue-router'

// Login Form
import LoginForm from '@/containers/Login'
import ForgotPassword from '@/containers/ForgotPassword'
import ResetPassword from '@/containers/ResetPassword'

import Page403 from '@/views/pages/Page403'
// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')
import UserList from '@/containers/admin/users/UserList'
import RoleList from '@/containers/admin/users/RoleList'
import ReservationsList from '@/containers/admin/reservations/ReservationsList'
import GateReservationsList from '@/containers/admin/reservations/GateReservationsList'
import AccomodationReservationsList from '@/containers/admin/reservations/AccomodationReservationsList'
import ReservationsPayment from '@/containers/admin/reservations/ReservationsPayment'
import AdminBooking from '@/containers/admin/reservations/AdminBooking'
import BuildingList from '@/containers/admin/buildings/BuildingList'
import FloorList from '@/containers/admin/buildings/FloorList'
import RoomList from '@/containers/admin/buildings/RoomList'
import AttributeList from '@/containers/admin/buildings/AttributeList'

import OccupancyReport from '@/containers/admin/reports/OccupancyReport'
import OccupancyOverview from '@/containers/admin/reports/OccupancyOverview'
import RevenueReport from '@/containers/admin/reports/RevenueReport'
import EventReport from '@/containers/admin/reports/EventReport'
import VisitorsReport from '@/containers/admin/reports/VisitorsReport'
import ManualRoomAllocation from '@/containers/admin/reservations/ManualRoomAllocateList'
import AadharCardScan from '@/containers/admin/samadh/AadharCardScan'
import SecurityPoint from '@/containers/admin/samadh/SecurityPoint'
import VisitHours from '@/containers/admin/samadh/VisitHours'
import SamadhPendingVisitors from '@/containers/admin/samadh/reports/SamadhPendingVisitors'
import SamadhVisitorEntryReport from '@/containers/admin/samadh/reports/SamadhVisitorEntryReport'
import SamadhVisitorsInformationReport from '@/containers/admin/samadh/reports/SamadhVisitorsInformationReport'
import ExitPoint from '@/containers/admin/samadh/ExitPoint'
import Accomodation from '@/containers/components/Accomodation'
import OfficePos from '@/containers/admin/pos/OfficePos'
import OfficeCategories from '@/containers/admin/pos/OfficeCategories'
import OfficeProducts from '@/containers/admin/pos/OfficeProducts'
import AmountDueByPeriodsReport from '@/containers/admin/electrical/reports/AmountDueByPeriodsReportForm'
import AmountDueByGroupsReport from '@/containers/admin/electrical/reports/AmountDueByGroupsReportForm'
import ElectricLoadReport from '@/containers/admin/electrical/reports/ElectricLoadReportForm'
import AmountDueBySelectionReport from '@/containers/admin/electrical/reports/AmountDueBySelectionReportForm'
import PaymentReceivedByDateReport from '@/containers/admin/electrical/reports/PaymentReceivedByDateReportForm'
import ChargeTypeList from '@/containers/admin/electrical/ChargeTypeList'
import ElectricLineList from '@/containers/admin/electrical/ElectricLineList'
import ProfileList from '@/containers/admin/electrical/SatsangiProfileList'
import HouseReadings from '@/containers/admin/electrical/HouseReadings'
import HouseReadingEdit from '@/containers/admin/electrical/HouseReadingEdit'
import BookCentrePos from '@/containers/admin/pos/BookCentrePos'
import BookCentreLowStock from '@/containers/admin/pos/BookCentreLowStock'
import BookCentreSaleByRange from '@/containers/admin/pos/BookCentreSaleByRange'

import BookCentreCategories from '@/containers/admin/pos/BookCentreCategories'
import BookCentreProducts from '@/containers/admin/pos/BookCentreProducts'
import BhandarGharPos from '@/containers/admin/pos/BhandarGharPos'
import BhandargharCategories from '@/containers/admin/pos/BhandargharCategories'
import BhandargharProducts from '@/containers/admin/pos/BhandargharProducts'
import DevicesList from '@/containers/admin/pos/DevicesList'
import PatientEntryForm from '@/containers/admin/dispensary/PatientEntryForm'
import VaccinationEntryForm from '@/containers/admin/vims/VimsEntryForm'
import VaccinationUpdateForm from '@/containers/admin/vims/VimsPersonList'
import VisitorEntry from '@/containers/admin/entrygate/VisitorEntry'
import GateVisitorEntry from '@/containers/admin/entrygate/GateVisitorEntry'
import NonSatsangiEntry from '@/containers/admin/entrygate/NonSatsangiEntry'
import GatePendingVisitors from '@/containers/admin/entrygate/GatePendingVisitors'
import GateExitStatus from '@/containers/admin/entrygate/GateExitStatus'
import NonSatsangiVisitReport from '@/containers/admin/entrygate/NonSatsangiVisitReport'






import Dictionary from '@/containers/admin/dictionary/Dictionary'


import ReportGateEntryByDates from '@/containers/admin/reports/ReportGateEntryByDates'
import SatsangiArrivalReport from '@/containers/admin/reports/SatsangiArrivalReport'

import ListGateEntries from '@/containers/admin/reports/ListGateEntries'





// Views

const Dashboard = () => import('@/containers/Dashboard')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      meta: {auth: true},
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '403',
          name: '403',
          component: Page403
        },
        {
          path: 'manage-users',
          redirect: { name: 'Users'},
          name: 'Manage Users',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'users',
              name: 'Users',
              component: UserList,
              meta: {
                title: 'Manage Users',
                auth: ['manage-users']
              }
            },
            {
              path: 'roles',
              name: 'Roles',
              component: RoleList,
              meta: {
                title: 'Manage Roles',
                auth: ['manage-roles']
              }
            }
          ]
        },
        {
          path: 'manage-gate-entry',
          redirect: { name: 'gate-visitor-entry'},
          name: 'Manage Gate Entry',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
              {            
                path: 'gate-security',
                name: 'gate-security',
                component: VisitorEntry,
                meta: {
                  title: 'Gate Security',
                  auth: ['gate-reservations-obsolete']
                }
            },
            {            
              path: 'gate-visitor-entry',
              name: 'gate-visitor-entry',
              component: GateVisitorEntry,
              meta: {
                title: 'Gate Visitor Entry',
                auth: ['gate-visitor-entry']
              }
            },
            {            
              path: 'gate-pending-visitors',
              name: 'gate-pending-visitors',
              component: GatePendingVisitors,
              meta: {
                title: 'Pending Visitors Report',
                auth: ['gate-pending-visitor']
              }
            },

            {            
              path: 'gate-exit-status',
              name: 'gate-exit-status',
              component: GateExitStatus,
              meta: {
                title: 'Exit Scan Ticket',
                auth: ['gate-pending-visit-status-update']
              }
            },

            {            
              path: 'gate-non-satsangi-visitors',
              name: 'gate-non-satsangi-visitors',
              component: NonSatsangiVisitReport,
              meta: {
                title: 'Non Satsangi Visitors Report',
                auth: ['gate-non-satsangi-visitors']
              }
            },
            {            
              path: 'non-satsangi-entry',
              name: 'non-satsangi-entry',
              component: NonSatsangiEntry,
              meta: {
                title: 'Gate Visitor Entry',
                auth: ['gate-visitor-entry']
              }
            },
           
            
          ]
        },
        {
          path: 'manage-reservations',
          redirect: { name: 'Reservations'},
          name: 'Manage Reservations',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'reservations',
              name: 'Reservations',
              component: ReservationsList,
              meta: {
                title: 'Manage Reservations',
                auth: ['manage-reservations']
              }
            },
            {
              path: 'accomodation-reservations',
              name: 'accomodation-reservations',
              component: AccomodationReservationsList,
              meta: {
                title: 'Accomodation Check In',
                auth: ['acco-checkin', 'print-bhandarghar-ticket']
              }
            },
            {
              path: 'gate-reservations',
              name: 'gate-reservations',
              component: GateReservationsList,
              meta: {
                title: 'Gate Check In',
                auth: ['gate-reservations']
              }
            },
            {
              path: 'payments',
              name: 'Bhent',
              component: ReservationsPayment,
              meta: {
                title: 'Bhent',
                auth: ['bhent']
              }
            },
            {
              path: 'manual-reservation',
              name: 'Manual Room Allocation',
              component: ManualRoomAllocation,
              meta: {
                title: 'Manual Room Allocationt',
                auth: ['visitor-report']
              }
            },
            {
              path: 'admin-booking',
              name: 'AdminBooking',
              component: AdminBooking,
              meta: {
                title: 'Admin Booking',
                auth: ['admin-booking']
              }
            },
          ]
        },
        {
          path: 'manage-buildings',
          redirect: { name: 'Buildings'},
          name: 'Manage Buildings',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'buildings',
              name: 'Buildings',
              component: BuildingList,
              meta: {
                title: 'Manage Buildings',
                auth: ['manage-buildings']
              }
            },
            {
              path: 'buildings/:id/floors',
              name: 'Floors',
              component: FloorList,
              meta: {
                title: 'Manage Floors',
                auth: ['manage-buildings']
              }
            },
            {
              path: 'buildings/:building_id/floors/:floor_id/rooms',
              name: 'Rooms',
              component: RoomList,
              meta: {
                title: 'Manage Rooms',
                auth: ['manage-buildings']
              }
            },
            {
              path: 'attributes',
              name: 'Attributes',
              component: AttributeList,
              meta: {
                title: 'Manage Attributes',
                auth: ['manage-attributes']
              }
            },
          ]
        },
        {
          path: 'electrical',
          redirect: { name: 'Satsangi Profiles'},
          name: 'Electrical',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'bhaint-types',
              name: 'Bhaint Types',
              component: ChargeTypeList,
              meta: {
                title: 'Bhaint Types',
                auth: ['electrical-bhaint-types']
              }
            },
            {
              path: 'electric-lines',
              name: 'Electric Lines',
              component: ElectricLineList,
              meta: {
                title: 'Electric Lines',
                auth: ['electrical-electric-lines']
              }
            },
            {
              path: 'bulk-readings',
              name: 'Monthly Readings',
              component: HouseReadings,
              meta: {
                title: 'Monthly Readings',
                auth: ['electrical-bulk-readings']
              }
            },
            {
              path: 'single-reading',
              name: 'Modify Reading',
              component: HouseReadingEdit,
              meta: {
                title: 'Modify Reading',
                auth: ['electrical-single-reading']
              }
            },
            {
              path: 'profiles',
              name: 'Satsangi Profiles',
              component: ProfileList,
              meta: {
                title: 'Satsangi Profiles',
                auth: ['electrical-profiles']
              }
            },

            {
              path: 'reports/overall-overdues',
              name: 'Overdues By Periods',
              component: AmountDueByPeriodsReport,
              meta: {
                title: 'Overdues By Periods Report',
                auth: ['electrical-overall-overdues']
              }
            },
            {
              path: 'reports/group-overdues',
              name: 'Overdues By Groups',
              component: AmountDueByGroupsReport,
              meta: {
                title: 'Overdues By Groups Report',
                auth: ['electrical-group-overdues']
              }
            },
            {
              path: 'reports/electric-lines',
              name: 'Electric Lines Load',
              component: ElectricLoadReport,
              meta: {
                title: 'Electric Lines Load Report',
                auth: ['electrical-lines-load']
              }
            },
            {
              path: 'reports/periods-overdues',
              name: 'Overdues By Selection Period',
              component: AmountDueBySelectionReport,
              meta: {
                title: 'Overdues By Selection Periods Report',
                auth: ['electrical-periods-overdues']
              }
            },
            {
              path: 'reports/daily-collection',
              name: 'Daily Payment Collection',
              component: PaymentReceivedByDateReport,
              meta: {
                title: 'Payment Received By Date Report',
                auth: ['electrical-daily-collection']
              }
            },
          ]
        },
        {
          path: 'samadh',
          redirect: { name: 'AadharCard Entry'},
          name: 'Samadh',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'aadharcard-scanner',
              name: 'AadharCard Entry',
              component: AadharCardScan,
              meta: {
                title: 'AadharCard Entry',
                auth: ['samadh-aadharcard-entry']
              }
            },
            {
              path: 'security-check',
              name: 'Security Check',
              component: SecurityPoint,
              meta: {
                title: 'Security Check',
                auth: ['samadh-security-check']
              }
            },
            {
              path: 'visit-hours',
              name: 'Visit Hours',
              component: VisitHours,
              meta: {
                title: 'Visit Hours',
                auth: ['samadh-visit-hours']
              }
            },
            {
              path: 'exit-point',
              name: 'Exit Point',
              component: ExitPoint,
              meta: {
                title: 'Exit Point',
                auth: ['samadh-exit-point']
              }
            },

            {
              path: 'reports/pending-visitors',
              name: 'Samadh Pending Visitors',
              component: SamadhPendingVisitors,
              meta: {
                title: 'Samadh Pending Visitors',
                auth: ['samadh-pending-visitors']
              }
            },

            {
              path: 'reports/visitors-entry-report',
              name: 'Visitors Entry Report',
              component: SamadhVisitorEntryReport,
              meta: {
                title: 'Visitors Entry Report',
                auth: ['samadh-visitors-entry-report']
              }
            },
            {
              path: 'reports/visitors-information-report',
              name: 'Visitors Information Report',
              component: SamadhVisitorsInformationReport,
              meta: {
                title: 'Visitors Information Report',
                auth: ['samadh-visitors-information-report']
              }
            },
          ]
        },
        {
          path: 'office',
          redirect: { name: 'Office Pos'},
          name: 'Office Pos',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'pos',
              name: 'Office Pos',
              component: OfficePos,
              meta: {
                title: 'Office Pos',
                auth: ['office-pos']
              }
            },
            {
              path: 'categories',
              name: 'Office Categories',
              component: OfficeCategories,
              meta: {
                title: 'Office Categories',
                auth: ['office-categories']
              }
            },
            {
              path: 'products',
              name: 'Office Products',
              component: OfficeProducts,
              meta: {
                title: 'Office Products',
                auth: ['office-products']
              }
            },
          ]
        },
        {
          path: 'dispensary',
          redirect: { name: 'Patient Entry Form'},
          name: 'Dispensary',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'entryform',
              name: 'Patient Entry Form',
              component: PatientEntryForm,
              meta: {
                title: 'Patient Entry Form',
                auth: ['patient-entry-form']
              }
            },
          ]
        },
        {
          path: 'vaccination',
          redirect: { name: 'Vaccination Entry Form'},
          name: 'Vaccination',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'entryform',
              name: 'Vaccination Entry Form',
              component: VaccinationEntryForm,
              meta: {
                title: 'Vaccination Entry Form',
                auth: ['vaccination-entry-form']
              }
            },
            {
              path: 'listform',
              name: 'Vaccination List',
              component: VaccinationUpdateForm,
              meta: {
                title: 'Vaccination List Form',
                auth: ['vaccination-entry-form']
              }
            },

          ]
        },
        {
          path: 'bhandarghar',
          redirect: { name: 'BhandargharPos Pos'},
          name: 'BhandargharPos Pos',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'pos',
              name: 'BhandargharPos Pos',
              component: BhandarGharPos,
              meta: {
                title: 'BhandargharPos Pos',
                auth: ['bhandarghar-pos']
              }
            },
            {
              path: 'categories',
              name: 'Bhandarghar Categories',
              component: BhandargharCategories,
              meta: {
                title: 'Bhandarghar Categories',
                auth: ['bhandarghar-categories']
              }
            },
            {
              path: 'products',
              name: 'Bhandarghar Products',
              component: BhandargharProducts,
              meta: {
                title: 'Bhandarghar Products',
                auth: ['bhandarghar-products']
              }
            },
            {
              path: 'devices',
              name: 'Bhandarghar Devices',
              component: DevicesList,
              meta: {
                title: 'Bhandarghar Devices',
                auth: ['bhandarghar-devices']
              }
            },
          ]
        },
        {
          path: 'bookcentre',
          redirect: { name: 'Bookcentre Pos'},
          name: 'Bookcentre Pos',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'pos',
              name: 'Bookcentre Pos',
              component: BookCentrePos,
              meta: {
                title: 'Bookcentre Pos',
                auth: ['bookcentre-pos']
              }
            },
            {
              path: 'categories',
              name: 'Bookcentre Categories',
              component: BookCentreCategories,
              meta: {
                title: 'Bookcentre Categories',
                auth: ['bookcentre-categories']
              }
            },
            {
              path: 'products',
              name: 'Bookcentre Products',
              component: BookCentreProducts,
              meta: {
                title: 'Bookcentre Products',
                auth: ['bookcentre-products']
              }
            },
            {
              path: 'low-inventory-report',
              name: 'Low Inventory Report',
              component: BookCentreLowStock,
              meta: {
                title: 'Low Inventory Report',
                auth: ['bookcentre-low-inventory-report']
              }
            },
            {
              path: 'sale-by-date',
              name: 'Sale By Date',
              component: BookCentreSaleByRange,
              meta: {
                title: 'Sale By Date',
                auth: ['bookcentre-low-inventory-report']
              }
            },



          ]
        },
        {
          path: 'reports',
          redirect: { name: 'Occupancy Report'},
          name: 'Reports',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'occupancy-by-range',
              name: 'Occupancy Report',
              component: OccupancyReport,
              meta: {
                title: 'Occupancy Report',
                auth: ['occupancy-report']
              }
            },
            {
              path: 'occupancy-overview',
              name: 'Occupancy Overview',
              component: OccupancyOverview,
              meta: {
                title: 'Occupancy Overview',
                auth: ['occupancy-overview']
              }
            },
            {
              path: 'revenue-by-range',
              name: 'Bhent Received Report',
              component: RevenueReport,
              meta: {
                title: 'Revenue Report',
                auth: ['bhent-received-report']
              }
            },
            {
              path: 'event',
              name: 'Bhandara/Satsang Report',
              component: EventReport,
              meta: {
                title: 'Bhandara/Satsang Report',
                auth: ['event-report']
              }
            },
            {
              path: 'visitors-by-range',
              name: 'Visitors Report',
              component: VisitorsReport,
              meta: {
                title: 'Visitors Report',
                auth: ['visitor-report']
              }
            },
            {
              path: 'satsangi-arrival-report',
              name: 'Satsangi Arrival Report',
              component: SatsangiArrivalReport,
              meta: {
                title: 'Satsangi Arrival Report',
                auth: ['satsangi-arrival-report']
              }
            },
            {
              path: 'gate-entries-report',
              name: 'Gate Entries By Dates',
              component: ReportGateEntryByDates,
              meta: {
                title: 'Gate Entries By Dates',
                auth: ['gate-entries-report']
              }
            },
            {
              path: 'list-gate-entries',
              name: 'List Gate Entries',
              component: ListGateEntries,
              meta: {
                title: 'List Gate Entries',
                auth: ['gate-entries-report']
              }
            }
            
          ]
        }
      ]
    },
    {
      path: '/login',
      name: 'LoginForm',
      component: LoginForm
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/accomodation',
      name: 'Accomodation',
      component: Accomodation,
      meta: {
        title: 'RS SoamiBagh'
      }
    },
    {
      path: '/dictionary',
      name: 'Dictionary',
      component: Dictionary,
      meta: {
        title: 'Dictionary'
      }
    }
  ]
})
